/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
// chakra imports
import { Box, Flex, HStack, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  const { t } = useTranslation();
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes, collapsed = false } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <>
            <Text
              fontSize={"md"}
              color={activeColor}
              fontWeight='bold'
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt='18px'
              pb='12px'
              key={index}>
              {t(route.name)}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <NavLink key={index} to={(route.external == true ? route.path : route.layout + route.path)}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={collapsed ? '0px' : (activeRoute(route.path.toLowerCase()) ? "22px" : "26px")}
                  py='8px'
                  ps={collapsed ? '6px' : '10px'}>
                  <Flex w='100%' alignItems='center' justifyContent='center'>
                    {collapsed ? (
                      <Tooltip label={t(route.name)} placement='right'>
                        <Box
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeIcon
                              : textColor
                          }
                          me='0'
                          fontSize='28px'
                          display='flex'
                          alignItems='center'
                          justifyContent='center'>
                          {route.icon}
                        </Box>
                      </Tooltip>
                    ) : (
                      <Box
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeIcon
                            : textColor
                        }
                        me='18px'
                        fontSize='20px'
                        display='flex'
                        alignItems='center'
                        justifyContent='center'>
                        {route.icon}
                      </Box>
                    )}
                    {collapsed ? null : (
                      <Tooltip label={t(route.name)} isDisabled placement='right'>
                        <Text
                          me='auto'
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeColor
                              : textColor
                          }
                          fontWeight={
                            activeRoute(route.path.toLowerCase())
                              ? "bold"
                              : "normal"
                          }>
                          {t(route.name)}
                        </Text>
                      </Tooltip>
                    )}
                  </Flex>
                  {collapsed ? null : (
                    <Box
                      h='36px'
                      w='4px'
                      bg={
                        activeRoute(route.path.toLowerCase())
                          ? brandColor
                          : "transparent"
                      }
                      borderRadius='5px'
                    />
                  )}
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={collapsed ? '0px' : (activeRoute(route.path.toLowerCase()) ? "22px" : "26px")}
                  py='8px'
                  ps={collapsed ? '6px' : '10px'}>
                  {collapsed ? null : (
                    <Text
                      me='auto'
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : inactiveColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                      }>
                      {t(route.name)}
                    </Text>
                  )}
                  {collapsed ? null : (
                    <Box h='36px' w='4px' bg='brand.400' borderRadius='5px' />
                  )}
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
